module.exports = __webpack_public_path__ + "media/app/assets/imgs/landing_2025/card-2-2a9671cc9a25006e2a0ded67b7e31731.png";